<template>
    <div class="portfolio-team-caree col d-none d-md-block sidebar">
        <div>
            <ul class="side-nav-list">
                <router-link to="/portfolio">
                    <a href="/portfolio" class="portfolio-team-caree">Portfolio</a>
                </router-link>
                <router-link to="/team">
                    <a href="/team" class="portfolio-team-caree">Team</a>
                </router-link>
                <router-link to="/careers">
                    <a href="/careers" class="portfolio-team-caree">Careers</a>
                </router-link>
                <router-link to="/ces">
                    <a href="/ces" class="portfolio-team-caree">CES</a>
                </router-link>
                <!--router-link to="/labday">
                    <a href="/labday" class="portfolio-team-caree">Lab Day</a>
                </router-link-->
                <router-link to="/office">
                    <a href="/office" class="portfolio-team-caree">Office</a>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data: function(){
            return {
                "isHidden": true,
            };
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/shared/SideNav.vue